import * as React from "react"

const NoDataShow = (props) => (
<svg
    xmlns="http://www.w3.org/2000/svg"
    width={270.95}
    height={250.502}
    {...props}
  >
    <defs>
      <clipPath id="a">
        <path
          data-name="Rectangle 57194"
          fill="none"
          d="M0 0h257.289v.875H0z"
        />
      </clipPath>
      <clipPath id="b">
        <path data-name="Rectangle 57196" fill="none" d="M0 0h3.637v6.047H0z" />
      </clipPath>
      <clipPath id="c">
        <path data-name="Rectangle 57197" fill="none" d="M0 0h3.471v6.31H0z" />
      </clipPath>
      <clipPath id="d">
        <path data-name="Rectangle 57198" fill="none" d="M0 0h5.925v3.93H0z" />
      </clipPath>
      <clipPath id="e">
        <path data-name="Rectangle 57199" fill="none" d="M0 0h6.043v3.82H0z" />
      </clipPath>
      <clipPath id="f">
        <path data-name="Rectangle 57200" fill="none" d="M0 0h6.042v3.82H0z" />
      </clipPath>
      <clipPath id="g">
        <path data-name="Rectangle 57204" fill="none" d="M0 0h8.233v8.086H0z" />
      </clipPath>
      <clipPath id="h">
        <path data-name="Rectangle 57205" fill="none" d="M0 0h3.242v2.918H0z" />
      </clipPath>
      <clipPath id="i">
        <path data-name="Rectangle 57206" fill="none" d="M0 0h6.999v.375H0z" />
      </clipPath>
      <clipPath id="j">
        <path
          data-name="Rectangle 57207"
          fill="#f26c40"
          d="M0 0h29.57v8.731H0z"
        />
      </clipPath>
      <clipPath id="k">
        <path
          data-name="Rectangle 57208"
          fill="none"
          d="M0 0h13.511v5.008H0z"
        />
      </clipPath>
      <clipPath id="l">
        <path
          data-name="Rectangle 57209"
          fill="none"
          d="M0 0h12.669v10.524H0z"
        />
      </clipPath>
      <clipPath id="m">
        <path
          data-name="Rectangle 57210"
          fill="none"
          d="M0 0h7.026v13.056H0z"
        />
      </clipPath>
      <clipPath id="n">
        <path data-name="Rectangle 57211" fill="none" d="M0 0h9.267v5.138H0z" />
      </clipPath>
      <clipPath id="o">
        <path data-name="Rectangle 57214" fill="none" d="M0 0h5.337v2.457H0z" />
      </clipPath>
      <clipPath id="p">
        <path
          data-name="Rectangle 57215"
          fill="#f47e58"
          d="M0 0h13.173v3.674H0z"
        />
      </clipPath>
      <clipPath id="q">
        <path
          data-name="Rectangle 57216"
          fill="none"
          d="M0 0h12.449v2.671H0z"
        />
      </clipPath>
      <clipPath id="r">
        <path data-name="Rectangle 57217" fill="none" d="M0 0h4.394v6.231H0z" />
      </clipPath>
      <clipPath id="s">
        <path data-name="Rectangle 57218" fill="none" d="M0 0h2.791v6.98H0z" />
      </clipPath>
    </defs>
    <g data-name="Group 112311">
      <g data-name="Group 112177">
        <g data-name="Group 112312">
          <g data-name="Group 112116">
            <g data-name="Group 112313">
              <g data-name="Group 112111" opacity={0.2}>
                <g data-name="Group 112110">
                  <g data-name="Group 112314">
                    <path
                      data-name="Path 100217"
                      d="M59.539 74.565a.615.615 0 0 1-.186-.029 11.2 11.2 0 0 1-2.889-1.488.616.616 0 0 1 .7-1.014 10.13 10.13 0 0 0 2.564 1.328.615.615 0 0 1-.186 1.2m2.9-.372a.615.615 0 0 1-.4-1.08 5.8 5.8 0 0 0 1.419-2.345.615.615 0 0 1 1.154.428 6.88 6.88 0 0 1-1.767 2.848.613.613 0 0 1-.4.15m-8-2.991a.613.613 0 0 1-.427-.172 21.966 21.966 0 0 1-2.116-2.355.615.615 0 1 1 .973-.754 20.745 20.745 0 0 0 2 2.223.615.615 0 0 1-.427 1.059m10.357-2.583a.616.616 0 0 1-.608-.717 23.535 23.535 0 0 0 .3-2.983.615.615 0 0 1 1.23.046 24.751 24.751 0 0 1-.313 3.139.616.616 0 0 1-.606.514m-14.1-2.28a.615.615 0 0 1-.542-.324 14.26 14.26 0 0 1-1.214-2.972.615.615 0 1 1 1.187-.325 13.037 13.037 0 0 0 1.111 2.714.616.616 0 0 1-.541.907m14.335-3.858a.615.615 0 0 1-.613-.565 21.161 21.161 0 0 0-.446-2.955.615.615 0 1 1 1.2-.274 22.389 22.389 0 0 1 .472 3.127.615.615 0 0 1-.563.664h-.051M49.22 60.448h-.047a.615.615 0 0 1-.567-.66 7.444 7.444 0 0 1 .684-2.625c.087-.185.184-.371.289-.553a.615.615 0 1 1 1.066.615 6.4 6.4 0 0 0-.242.463 6.217 6.217 0 0 0-.57 2.193.615.615 0 0 1-.613.569m14.4-3.927a.615.615 0 0 1-.558-.355 7.107 7.107 0 0 0-1.616-2.3.615.615 0 1 1 .823-.915 8.319 8.319 0 0 1 1.907 2.694.616.616 0 0 1-.557.876m-11.514-1.316a.615.615 0 0 1-.4-1.087 11.747 11.747 0 0 1 2.75-1.714.616.616 0 1 1 .5 1.125 10.5 10.5 0 0 0-2.458 1.531.613.613 0 0 1-.4.144m8.568-1.976a.613.613 0 0 1-.261-.059 4.823 4.823 0 0 0-2.065-.422c-.2 0-.412.01-.624.03a.615.615 0 0 1-.114-1.225c.249-.023.5-.035.738-.035a6.04 6.04 0 0 1 2.589.539.616.616 0 0 1-.262 1.172"
                      fill="#f47e58"
                    />
                    <path
                      data-name="Path 100218"
                      d="M35.416 91.101h-.01a31.138 31.138 0 0 1-3.131-.216.615.615 0 1 1 .148-1.222 29.93 29.93 0 0 0 3.006.207.616.616 0 0 1-.012 1.231m3.076-.08a.615.615 0 0 1-.043-1.229c1-.071 2.012-.186 3-.343a.616.616 0 0 1 .192 1.216 36.577 36.577 0 0 1-3.11.355h-.044m-9.169-.68a.613.613 0 0 1-.148-.018 20.715 20.715 0 0 1-3.012-.984.615.615 0 1 1 .475-1.135 19.476 19.476 0 0 0 2.832.925.616.616 0 0 1-.147 1.213m15.242-.283a.615.615 0 0 1-.15-1.212 28.967 28.967 0 0 0 2.881-.881.615.615 0 0 1 .423 1.156 30.268 30.268 0 0 1-3 .918.622.622 0 0 1-.151.019m-20.873-2.122a.613.613 0 0 1-.345-.106 12.738 12.738 0 0 1-2.424-2.124.615.615 0 0 1 .925-.812 11.508 11.508 0 0 0 2.191 1.918.615.615 0 0 1-.346 1.125m26.629-.022a.615.615 0 0 1-.291-1.158 12.572 12.572 0 0 0 2.421-1.642.615.615 0 0 1 .818.919 13.785 13.785 0 0 1-2.659 1.808.613.613 0 0 1-.29.073m4.3-4.2a.616.616 0 0 1-.585-.808 3.565 3.565 0 0 0 .174-1.118 5.022 5.022 0 0 0-.258-1.524.615.615 0 0 1 1.172-.376 6.247 6.247 0 0 1 .317 1.9 4.793 4.793 0 0 1-.236 1.5.616.616 0 0 1-.584.423m-34.932-.359a.615.615 0 0 1-.553-.344 14.64 14.64 0 0 1-1.081-3.019.617.617 0 1 1 1.2-.288 13.414 13.414 0 0 0 .989 2.765.616.616 0 0 1-.552.887m33.441-5.387a.615.615 0 0 1-.506-.265 19.508 19.508 0 0 0-1.9-2.3.615.615 0 0 1 .891-.849 20.759 20.759 0 0 1 2.019 2.445.616.616 0 0 1-.505.966m-34.892-.549a.615.615 0 0 1-.615-.594c-.007-.187-.01-.377-.01-.564a15.416 15.416 0 0 1 .224-2.628.616.616 0 1 1 1.213.21 14.185 14.185 0 0 0-.205 2.417c0 .172 0 .348.009.521a.615.615 0 0 1-.593.637h-.022m30.692-3.935a.613.613 0 0 1-.4-.148 36.773 36.773 0 0 0-2.38-1.872.616.616 0 1 1 .721-1 38.28 38.28 0 0 1 2.46 1.935.615.615 0 0 1-.4 1.083m-29.619-2.073a.616.616 0 0 1-.564-.86 11.455 11.455 0 0 1 1.684-2.768.615.615 0 1 1 .947.786 10.229 10.229 0 0 0-1.5 2.471.616.616 0 0 1-.565.371m24.629-1.527a.613.613 0 0 1-.314-.087l-.307-.18a38.105 38.105 0 0 0-2.686-1.408.615.615 0 0 1 .529-1.111c.969.461 1.9.95 2.773 1.454l.321.188a.615.615 0 0 1-.316 1.144m-5.872-2.831a.613.613 0 0 1-.22-.041 32.722 32.722 0 0 0-2.866-.955.615.615 0 0 1 .332-1.185 32.8 32.8 0 0 1 2.975.991.615.615 0 0 1-.221 1.19m-14.859-.279a.615.615 0 0 1-.326-1.138 10.651 10.651 0 0 1 3-1.266.615.615 0 1 1 .306 1.192 9.425 9.425 0 0 0-2.65 1.118.613.613 0 0 1-.325.093m8.934-1.353a.618.618 0 0 1-.094-.007 18.136 18.136 0 0 0-2.737-.22H29.086a.616.616 0 0 1-.009-1.231h.245a19.362 19.362 0 0 1 2.924.235.615.615 0 0 1-.093 1.224"
                      fill="#f47e58"
                    />
                    <path
                      data-name="Path 100219"
                      d="M43.282 192.322a.616.616 0 0 1 0-1.231c1 0 2.028-.017 3.06-.046a.615.615 0 0 1 .034 1.23c-1.043.029-2.083.045-3.092.046Zm-3.076-.038h-.016a98.05 98.05 0 0 1-3.091-.131.615.615 0 1 1 .072-1.228c.994.058 2.021.1 3.052.129a.615.615 0 0 1-.016 1.23m9.226-.131a.615.615 0 0 1-.031-1.23c1-.052 2.029-.116 3.058-.191a.615.615 0 1 1 .09 1.227c-1.037.076-2.075.141-3.084.193h-.032m-15.362-.232h-.058a83.028 83.028 0 0 1-3.078-.35.615.615 0 1 1 .164-1.22c.984.132 2 .248 3.029.345a.615.615 0 0 1-.057 1.228m21.5-.217a.615.615 0 0 1-.056-1.228c1-.093 2.024-.2 3.049-.313a.615.615 0 0 1 .137 1.223c-1.033.116-2.066.222-3.072.316h-.058m4.618-.5a.615.615 0 0 1-.148-1.213q1.487-.369 2.988-.738a.618.618 0 0 1 .294 1.2q-1.5.369-2.985.738a.618.618 0 0 1-.149.018m-32.206-.11a.616.616 0 0 1-.11-.01 66.242 66.242 0 0 1-3.04-.625.616.616 0 1 1 .279-1.2c.963.224 1.965.43 2.979.612a.615.615 0 0 1-.108 1.221m38.18-1.359a.615.615 0 0 1-.145-1.213c1.018-.247 2.025-.49 2.993-.722a.617.617 0 0 1 .286 1.2c-.967.231-1.972.474-2.988.721a.617.617 0 0 1-.146.018M22 189.702a.612.612 0 0 1-.174-.025 49.45 49.45 0 0 1-2.956-.972.615.615 0 1 1 .423-1.156c.924.338 1.893.657 2.879.947a.615.615 0 0 1-.172 1.206m50.145-1.392a.615.615 0 0 1-.14-1.215c1.008-.237 2.017-.471 3-.7a.616.616 0 1 1 .276 1.2c-.98.225-1.987.46-2.994.7a.611.611 0 0 1-.141.016m-55.907-.73a.613.613 0 0 1-.254-.055 37.02 37.02 0 0 1-2.787-1.409.615.615 0 1 1 .6-1.073c.854.479 1.76.937 2.694 1.361a.615.615 0 0 1-.255 1.176m61.9-.65a.615.615 0 0 1-.134-1.216 468.93 468.93 0 0 1 3.007-.666.615.615 0 1 1 .263 1.2c-.983.215-1.993.438-3 .664a.615.615 0 0 1-.135.015m6.011-1.313a.615.615 0 0 1-.127-1.218 414.92 414.92 0 0 1 3.015-.629.616.616 0 1 1 .248 1.206c-.985.2-2 .414-3.007.628a.61.61 0 0 1-.128.014m-73.25-1.048a.613.613 0 0 1-.351-.111 28.872 28.872 0 0 1-2.474-1.93.616.616 0 0 1 .81-.927 27.615 27.615 0 0 0 2.368 1.847.615.615 0 0 1-.352 1.12m79.283-.186a.615.615 0 0 1-.119-1.219c1.007-.2 2.024-.4 3.024-.588a.615.615 0 0 1 .231 1.209c-1 .19-2.011.388-3.015.587a.61.61 0 0 1-.12.012m6.043-1.154a.615.615 0 0 1-.11-1.221c1.006-.184 2.026-.368 3.032-.544a.615.615 0 1 1 .213 1.212c-1 .176-2.02.359-3.023.543a.623.623 0 0 1-.112.01m6.06-1.064a.615.615 0 0 1-.1-1.222 506.95 506.95 0 0 1 3.041-.5.615.615 0 0 1 .194 1.215c-1.006.161-2.026.328-3.031.5a.617.617 0 0 1-.1.009m6.076-.97a.615.615 0 0 1-.092-1.224c1.012-.153 2.038-.3 3.048-.45a.615.615 0 1 1 .175 1.218c-1.007.145-2.029.3-3.038.448a.613.613 0 0 1-.093.007m-102.081-.67a.614.614 0 0 1-.458-.2 24.364 24.364 0 0 1-1.952-2.475.616.616 0 1 1 1.014-.7 23.152 23.152 0 0 0 1.853 2.35.615.615 0 0 1-.458 1.027m108.161-.2a.615.615 0 0 1-.082-1.225c1.012-.137 2.04-.272 3.055-.4a.615.615 0 0 1 .155 1.221 377.77 377.77 0 0 0-3.045.4.621.621 0 0 1-.083.006m6.1-.776a.615.615 0 0 1-.072-1.227c1.016-.121 2.046-.239 3.061-.352a.615.615 0 1 1 .136 1.223c-1.012.112-2.039.23-3.051.351a.623.623 0 0 1-.073 0m6.115-.678a.615.615 0 0 1-.062-1.228c1.015-.1 2.047-.207 3.066-.3a.615.615 0 1 1 .116 1.225l-3.057.3a.583.583 0 0 1-.064 0m6.125-.581a.615.615 0 0 1-.053-1.229 432.91 432.91 0 0 1 3.07-.255.616.616 0 1 1 .1 1.227 425.57 425.57 0 0 0-3.061.254h-.054m6.134-.486a.615.615 0 0 1-.043-1.229 475.01 475.01 0 0 1 3.074-.208.615.615 0 0 1 .078 1.228c-1.021.065-2.053.135-3.065.207h-.044m6.14-.392a.615.615 0 0 1-.034-1.23c1.019-.057 2.054-.112 3.077-.162a.615.615 0 1 1 .06 1.229c-1.02.05-2.052.1-3.068.162h-.035m6.145-.3a.615.615 0 0 1-.025-1.23c1.017-.043 2.052-.082 3.078-.118a.615.615 0 0 1 .043 1.23c-1.023.035-2.056.075-3.07.117h-.026m33.837-.2c-.884 0-1.8-.018-2.718-.04l-.37-.009a.615.615 0 0 1 .029-1.23l.371.009c.912.022 1.818.036 2.694.04a.616.616 0 0 1 0 1.231m-27.688-.017a.615.615 0 0 1-.017-1.23c1.015-.028 2.051-.053 3.08-.075h.013a.616.616 0 0 1 .013 1.231c-1.026.021-2.059.046-3.071.074h-.017m30.762-.006a.616.616 0 0 1-.012-1.231c1.036-.021 2.064-.056 3.054-.105a.615.615 0 0 1 .06 1.229c-1 .049-2.041.085-3.089.106h-.013m-9.227-.09h-.011c-1.027-.018-2.06-.033-3.073-.045a.616.616 0 0 1 .007-1.231h.007c1.015.012 2.051.027 3.08.045a.616.616 0 0 1-.011 1.231m-15.383-.032a.616.616 0 0 1-.009-1.231c1.021-.014 2.057-.025 3.081-.033a.616.616 0 0 1 0 1.231c-1.02.008-2.054.019-3.072.033h-.009m9.23-.039c-.867 0-1.744-.007-2.608-.007h-.465a.616.616 0 0 1 0-1.231h.465c.866 0 1.746 0 2.615.007a.616.616 0 0 1 0 1.231m21.518-.145a.615.615 0 0 1-.05-1.229 95.362 95.362 0 0 0 3.034-.3.615.615 0 1 1 .146 1.222c-1 .12-2.035.224-3.08.31h-.051m6.1-.735a.615.615 0 0 1-.1-1.223 66.462 66.462 0 0 0 2.992-.556.615.615 0 1 1 .253 1.2c-.992.209-2.017.4-3.048.567a.619.619 0 0 1-.1.008m-197.539-.38a.615.615 0 0 1-.55-.339 22.467 22.467 0 0 1-1.218-2.919.616.616 0 0 1 1.167-.392 21.216 21.216 0 0 0 1.151 2.758.616.616 0 0 1-.549.892m203.549-.887a.616.616 0 0 1-.156-1.211 59.19 59.19 0 0 0 2.92-.848.616.616 0 1 1 .374 1.173c-.979.312-1.982.6-2.98.865a.612.612 0 0 1-.157.02m5.853-1.863a.616.616 0 0 1-.216-1.192 64.804 64.804 0 0 0 2.822-1.138.615.615 0 0 1 .487 1.13c-.961.414-1.929.8-2.876 1.16a.613.613 0 0 1-.216.039m5.646-2.423a.616.616 0 0 1-.267-1.17 91.609 91.609 0 0 0 2.729-1.368.615.615 0 1 1 .569 1.091c-.964.5-1.869.956-2.765 1.386a.613.613 0 0 1-.266.061m-217-.648a.616.616 0 0 1-.605-.509A16.031 16.031 0 0 1 0 166.42v-.246l.024-.274a.615.615 0 1 1 1.225.116l-.022.245v.159a14.943 14.943 0 0 0 .246 2.5.616.616 0 0 1-.607.722m222.451-2.184a.615.615 0 0 1-.3-1.154c.811-.447 1.685-.938 2.672-1.5a.615.615 0 0 1 .61 1.069c-.992.566-1.871 1.06-2.687 1.51a.612.612 0 0 1-.3.077m5.344-3.038a.615.615 0 0 1-.309-1.148l.985-.57 1.676-.97a.616.616 0 1 1 .616 1.066l-1.675.969-.985.57a.612.612 0 0 1-.308.083m-227.512-.88a.622.622 0 0 1-.145-.017.615.615 0 0 1-.454-.743 25.658 25.658 0 0 1 .931-3.008.616.616 0 0 1 1.152.434 24.425 24.425 0 0 0-.887 2.864.616.616 0 0 1-.6.471m232.838-2.191a.615.615 0 0 1-.305-1.15c.949-.541 1.827-1.035 2.684-1.512a.616.616 0 1 1 .6 1.076c-.853.475-1.727.967-2.673 1.506a.613.613 0 0 1-.3.081m5.374-2.986a.615.615 0 0 1-.293-1.157c.915-.494 1.832-.98 2.724-1.444a.615.615 0 1 1 .568 1.092c-.887.462-1.8.945-2.708 1.436a.613.613 0 0 1-.292.074M3.3 157.792a.616.616 0 0 1-.55-.891c.45-.9.962-1.82 1.521-2.734a.616.616 0 1 1 1.05.643 35.352 35.352 0 0 0-1.47 2.642.616.616 0 0 1-.551.34m241.516-2.281a.616.616 0 0 1-.292-1.158c.891-.479 1.78-.987 2.642-1.512a.616.616 0 0 1 .64 1.052 57.4 57.4 0 0 1-2.7 1.544.612.612 0 0 1-.291.074m-238.321-2.97a.615.615 0 0 1-.5-.973 53.527 53.527 0 0 1 1.886-2.477.615.615 0 1 1 .957.773 51.572 51.572 0 0 0-1.842 2.419.615.615 0 0 1-.5.258m243.573-.227a.615.615 0 0 1-.348-1.123 55.991 55.991 0 0 0 2.463-1.787.615.615 0 1 1 .75.976 57.624 57.624 0 0 1-2.517 1.826.613.613 0 0 1-.347.108m4.877-3.747a.615.615 0 0 1-.4-1.082 53.53 53.53 0 0 0 2.25-2.048.615.615 0 0 1 .854.886 55.882 55.882 0 0 1-2.3 2.094.613.613 0 0 1-.4.149m-244.591-.817a.615.615 0 0 1-.459-1.025 74.667 74.667 0 0 1 2.117-2.27.616.616 0 1 1 .883.858c-.725.747-1.426 1.5-2.082 2.232a.614.614 0 0 1-.459.205m249.019-3.451a.615.615 0 0 1-.452-1.033 53.682 53.682 0 0 0 2-2.293.615.615 0 0 1 .953.779 52.19 52.19 0 0 1-2.044 2.349.614.614 0 0 1-.452.2m-244.734-.968a.615.615 0 0 1-.426-1.06c.722-.692 1.485-1.4 2.269-2.108a.615.615 0 1 1 .824.914c-.774.7-1.529 1.4-2.242 2.083a.613.613 0 0 1-.426.171m248.626-3.794a.615.615 0 0 1-.5-.974 46.182 46.182 0 0 0 1.688-2.523.615.615 0 1 1 1.046.649c-.54.87-1.123 1.741-1.733 2.592a.615.615 0 0 1-.5.257m-244.057-.332a.615.615 0 0 1-.4-1.083 136.06 136.06 0 0 1 2.371-1.983.615.615 0 1 1 .78.952c-.808.662-1.6 1.323-2.35 1.966a.613.613 0 0 1-.4.148m4.761-3.9a.615.615 0 0 1-.381-1.1c.782-.617 1.58-1.236 2.439-1.893a.615.615 0 1 1 .748.977 221 221 0 0 0-2.425 1.882.612.612 0 0 1-.381.132m242.537-.992a.615.615 0 0 1-.544-.9 37.4 37.4 0 0 0 1.3-2.733.615.615 0 0 1 1.131.485c-.4.938-.854 1.887-1.345 2.821a.615.615 0 0 1-.545.329m-237.6-2.674a.615.615 0 0 1-.336-1.131c.889-.579 1.8-1.114 2.7-1.591a.615.615 0 0 1 .577 1.087c-.867.46-1.742.977-2.6 1.536a.614.614 0 0 1-.335.1m44.83-1.121h-.02a43.06 43.06 0 0 1-3.117-.158.615.615 0 0 1 .105-1.226c1.04.089 2.058.141 3.028.153a.616.616 0 0 1-.008 1.231m3.075-.092a.615.615 0 0 1-.045-1.229 31.67 31.67 0 0 0 2.994-.367.615.615 0 0 1 .209 1.213c-1.014.175-2.061.3-3.112.382h-.046m-9.2-.418a.637.637 0 0 1-.088-.006c-.952-.136-1.953-.3-3.059-.5a.616.616 0 1 1 .221-1.211c1.091.2 2.077.361 3.013.5a.615.615 0 0 1-.086 1.225m15.257-.63a.615.615 0 0 1-.165-1.208c.957-.266 1.92-.587 2.86-.952a.615.615 0 0 1 .446 1.147c-.978.38-1.979.713-2.976.99a.615.615 0 0 1-.165.023m-21.313-.456a.617.617 0 0 1-.124-.012q-.912-.186-1.822-.375l-1.194-.247a.616.616 0 1 1 .248-1.206l1.2.247q.908.188 1.817.374a.615.615 0 0 1-.122 1.219m-27.214-.153a.616.616 0 0 1-.233-1.185 29.55 29.55 0 0 1 2.965-1.033.615.615 0 1 1 .342 1.182 28.33 28.33 0 0 0-2.841.99.615.615 0 0 1-.233.046m234.577-.11a.616.616 0 0 1-.585-.807 30.96 30.96 0 0 0 .8-2.906.615.615 0 1 1 1.2.264c-.219.995-.5 2.012-.83 3.025a.616.616 0 0 1-.585.424m-213.4-.958a.626.626 0 0 1-.114-.011 85.505 85.505 0 0 0-3.011-.516.615.615 0 1 1 .184-1.217 86.4 86.4 0 0 1 3.055.523.615.615 0 0 1-.113 1.22m33.076-.541a.615.615 0 0 1-.275-1.166q.2-.1.391-.2c.768-.4 1.523-.823 2.243-1.271a.615.615 0 1 1 .65 1.045c-.748.465-1.532.909-2.329 1.32q-.2.1-.405.206a.613.613 0 0 1-.274.065m-48.359-.1a.615.615 0 0 1-.105-1.222 30.663 30.663 0 0 1 3.115-.379.616.616 0 1 1 .086 1.228 29.461 29.461 0 0 0-2.99.363.619.619 0 0 1-.107.009m9.2-.263h-.059a40.74 40.74 0 0 0-3.024-.179.616.616 0 0 1 .025-1.231c1.008.021 2.027.081 3.115.184a.615.615 0 0 1-.057 1.228m44.358-2.891a.615.615 0 0 1-.375-1.1 30.254 30.254 0 0 0 2.287-1.942.616.616 0 0 1 .842.9 31.623 31.623 0 0 1-2.38 2.021.613.613 0 0 1-.374.127m176.416-1.262h-.062a.616.616 0 0 1-.551-.674c.075-.747.113-1.491.113-2.211 0-.26 0-.521-.015-.777a.615.615 0 1 1 1.23-.047 22.43 22.43 0 0 1-.103 3.157.615.615 0 0 1-.611.554M98.263 119.73a.615.615 0 0 1-.463-1.02c.65-.744 1.28-1.536 1.87-2.355a.616.616 0 0 1 1 .72 33.444 33.444 0 0 1-1.942 2.445.614.614 0 0 1-.464.21m171.694-3.2a.616.616 0 0 1-.6-.492 15.5 15.5 0 0 0-.861-2.826.616.616 0 0 1 1.137-.472 16.744 16.744 0 0 1 .93 3.051.615.615 0 0 1-.479.727.623.623 0 0 1-.124.013m-168.1-1.762a.616.616 0 0 1-.528-.931c.5-.844.991-1.737 1.445-2.653a.615.615 0 1 1 1.1.547 40.393 40.393 0 0 1-1.491 2.737.615.615 0 0 1-.529.3m165.742-3.87a.615.615 0 0 1-.506-.264 13.074 13.074 0 0 0-1.929-2.2.615.615 0 0 1 .831-.908 14.494 14.494 0 0 1 2.108 2.4.615.615 0 0 1-.5.967m-163.014-1.621a.616.616 0 0 1-.568-.851 50.77 50.77 0 0 0 1.074-2.84.615.615 0 0 1 1.163.4c-.345 1-.715 1.978-1.1 2.909a.616.616 0 0 1-.569.38m158.538-2.517a.613.613 0 0 1-.325-.093 23.926 23.926 0 0 0-2.642-1.412.615.615 0 1 1 .517-1.117 25.169 25.169 0 0 1 2.776 1.485.615.615 0 0 1-.327 1.137m-5.548-2.628a.615.615 0 0 1-.217-.04 92.349 92.349 0 0 0-2.88-1.024.616.616 0 1 1 .4-1.165c1.165.4 2.092.726 2.919 1.038a.615.615 0 0 1-.218 1.191m-150.983-.66a.616.616 0 0 1-.592-.786c.273-.946.535-1.937.78-2.948a.617.617 0 1 1 1.2.289 71.473 71.473 0 0 1-.793 3 .616.616 0 0 1-.591.445m145.159-1.345a.612.612 0 0 1-.2-.032 169.71 169.71 0 0 1-2.921-1 .615.615 0 1 1 .409-1.161c1.03.363 2.045.705 2.9.991a.616.616 0 0 1-.195 1.2m-5.8-2.062a.616.616 0 0 1-.224-.042 72.78 72.78 0 0 1-2.866-1.193.616.616 0 0 1 .5-1.125c.9.4 1.818.783 2.814 1.171a.615.615 0 0 1-.224 1.189m-5.614-2.509a.612.612 0 0 1-.281-.068 50.127 50.127 0 0 1-2.723-1.509.616.616 0 0 1 .631-1.057c.851.509 1.745 1 2.655 1.471a.615.615 0 0 1-.282 1.163m-132.294-.063a.616.616 0 0 1-.6-.738c.2-.965.384-1.977.56-3.008a.615.615 0 1 1 1.213.207 97.697 97.697 0 0 1-.567 3.045.616.616 0 0 1-.6.493m127.021-3.091a.612.612 0 0 1-.35-.11 46.303 46.303 0 0 1-2.5-1.863.615.615 0 0 1 .77-.96c.784.629 1.6 1.238 2.429 1.812a.615.615 0 0 1-.351 1.121M109.1 91.419a.635.635 0 0 1-.088-.006.615.615 0 0 1-.521-.7c.14-.971.276-1.993.4-3.04a.616.616 0 1 1 1.222.15 145.323 145.323 0 0 1-.408 3.065.616.616 0 0 1-.608.528m121.189-.865a.613.613 0 0 1-.417-.163c-.754-.7-1.5-1.431-2.216-2.187a.615.615 0 1 1 .893-.847 46.49 46.49 0 0 0 2.157 2.129.615.615 0 0 1-.417 1.068m-4.224-4.46a.615.615 0 0 1-.477-.226 31.164 31.164 0 0 1-1.862-2.521.616.616 0 1 1 1.027-.679 29.935 29.935 0 0 0 1.788 2.421.615.615 0 0 1-.476 1m-116.211-.789h-.065a.616.616 0 0 1-.547-.677c.1-.975.2-1.975.3-3.057a.615.615 0 0 1 1.225.114c-.1 1.088-.2 2.093-.3 3.073a.616.616 0 0 1-.611.551m112.843-4.338a.615.615 0 0 1-.55-.338 28.344 28.344 0 0 1-1.254-2.878.615.615 0 0 1 1.153-.431 27.116 27.116 0 0 0 1.2 2.755.616.616 0 0 1-.549.893m-112.269-1.8h-.052a.615.615 0 0 1-.562-.665c.077-.919.158-1.924.249-3.073a.616.616 0 0 1 1.227.1c-.09 1.151-.172 2.158-.249 3.08a.616.616 0 0 1-.613.564m110.082-3.939a.616.616 0 0 1-.59-.442c-.219-.743-.421-1.475-.636-2.25l-.2-.719a.616.616 0 1 1 1.186-.33l.2.721c.213.77.414 1.5.63 2.23a.616.616 0 0 1-.591.789m-109.6-2.209h-.048a.615.615 0 0 1-.567-.661l.237-3.067a.616.616 0 1 1 1.227.1q-.12 1.528-.237 3.064a.615.615 0 0 1-.613.568m107.9-3.7a.616.616 0 0 1-.587-.43 49.621 49.621 0 0 0-1-2.864.616.616 0 0 1 1.148-.445c.361.932.7 1.893 1.028 2.938a.616.616 0 0 1-.587.8M111.4 66.888h-.052a.615.615 0 0 1-.562-.665c.093-1.107.182-2.113.272-3.074a.615.615 0 0 1 1.225.114c-.09.958-.178 1.96-.271 3.063a.615.615 0 0 1-.612.564m105.182-3.29a.615.615 0 0 1-.557-.352c-.424-.9-.893-1.8-1.393-2.695a.615.615 0 1 1 1.074-.6c.514.917 1 1.849 1.431 2.77a.616.616 0 0 1-.556.879m-104.6-2.844a.616.616 0 0 1-.613-.681c.114-1.066.234-2.1.356-3.071a.615.615 0 1 1 1.221.154c-.121.964-.24 1.99-.354 3.049a.616.616 0 0 1-.611.55m101.606-2.524a.615.615 0 0 1-.518-.282 54.117 54.117 0 0 0-1.72-2.509.617.617 0 0 1 1-.724 54.485 54.485 0 0 1 1.759 2.566.615.615 0 0 1-.517.949m-100.832-3.587a.616.616 0 0 1-.609-.707c.158-1.054.327-2.082.5-3.057a.615.615 0 1 1 1.211.218c-.174.963-.341 1.979-.5 3.021a.616.616 0 0 1-.608.524m97.218-1.391a.614.614 0 0 1-.479-.228 65.012 65.012 0 0 0-1.973-2.323.615.615 0 1 1 .919-.818c.695.78 1.371 1.577 2.011 2.368a.615.615 0 0 1-.478 1m-4.089-4.6a.614.614 0 0 1-.441-.186c-.7-.718-1.429-1.44-2.172-2.145a.615.615 0 0 1 .847-.893c.755.716 1.5 1.45 2.208 2.18a.615.615 0 0 1-.441 1.044m-92.029-.069a.616.616 0 0 1-.6-.747c.227-1.04.473-2.056.73-3.019a.615.615 0 0 1 1.189.317 67.024 67.024 0 0 0-.716 2.965.616.616 0 0 1-.6.484m87.564-4.168a.613.613 0 0 1-.406-.153 86.158 86.158 0 0 0-2.332-1.974.615.615 0 1 1 .778-.953c.8.657 1.6 1.33 2.366 2a.615.615 0 0 1-.406 1.078m-85.97-1.775a.616.616 0 0 1-.585-.807c.331-1.014.689-2 1.063-2.929a.615.615 0 1 1 1.142.459c-.364.9-.712 1.864-1.035 2.852a.616.616 0 0 1-.585.424m81.2-2.119a.613.613 0 0 1-.372-.126c-.8-.611-1.632-1.22-2.464-1.81a.615.615 0 1 1 .712-1c.843.6 1.683 1.215 2.5 1.834a.615.615 0 0 1-.373 1.105m-5.015-3.56a.613.613 0 0 1-.339-.1 96.318 96.318 0 0 0-2.573-1.648.615.615 0 1 1 .648-1.046c.876.542 1.753 1.1 2.6 1.669a.615.615 0 0 1-.341 1.128m-73.884-.015a.616.616 0 0 1-.55-.89 33.39 33.39 0 0 1 1.522-2.732.615.615 0 1 1 1.045.65 32.13 32.13 0 0 0-1.466 2.63.615.615 0 0 1-.551.341m68.654-3.223a.613.613 0 0 1-.307-.083 103.699 103.699 0 0 0-2.673-1.491.615.615 0 1 1 .583-1.084c.906.488 1.817 1 2.705 1.509a.615.615 0 0 1-.308 1.148m-65.405-1.971a.615.615 0 0 1-.484-.995 26.406 26.406 0 0 1 2.075-2.349.616.616 0 0 1 .872.869 25.167 25.167 0 0 0-1.978 2.239.614.614 0 0 1-.485.236m59.981-.948a.613.613 0 0 1-.275-.065c-.911-.456-1.84-.9-2.762-1.329a.615.615 0 1 1 .517-1.117c.933.432 1.873.884 2.8 1.345a.615.615 0 0 1-.276 1.166m-5.592-2.588a.613.613 0 0 1-.241-.049c-.938-.4-1.891-.788-2.833-1.155a.616.616 0 1 1 .447-1.147c.953.372 1.918.765 2.868 1.17a.615.615 0 0 1-.242 1.182m-50.071-.785a.615.615 0 0 1-.378-1.1 25.245 25.245 0 0 1 2.588-1.766.615.615 0 1 1 .629 1.058 24.015 24.015 0 0 0-2.461 1.68.613.613 0 0 1-.378.13m44.336-1.449a.614.614 0 0 1-.2-.035 91.311 91.311 0 0 0-2.9-.97.616.616 0 1 1 .371-1.174c.973.308 1.962.639 2.939.983a.615.615 0 0 1-.2 1.2m-39.089-1.681a.615.615 0 0 1-.251-1.178 29.707 29.707 0 0 1 2.934-1.121.615.615 0 0 1 .379 1.171 28.479 28.479 0 0 0-2.812 1.074.614.614 0 0 1-.25.053m33.219-.173a.616.616 0 0 1-.165-.023 83.646 83.646 0 0 0-2.958-.764.617.617 0 0 1 .286-1.2c.991.236 2 .5 3 .776a.615.615 0 0 1-.165 1.208m-5.987-1.426a.616.616 0 0 1-.12-.012 69.288 69.288 0 0 0-3.006-.527.616.616 0 0 1 .186-1.217c1 .154 2.033.334 3.057.536a.615.615 0 0 1-.118 1.219m-21.391-.3a.615.615 0 0 1-.133-1.216 38.235 38.235 0 0 1 3.077-.552.615.615 0 0 1 .169 1.219 37.02 37.02 0 0 0-2.978.534.618.618 0 0 1-.135.015m15.307-.624a.62.62 0 0 1-.066 0 60.156 60.156 0 0 0-3.036-.245.615.615 0 0 1 .067-1.229c1.013.055 2.056.14 3.1.25a.615.615 0 0 1-.064 1.227m-9.219-.229a.615.615 0 0 1-.04-1.229c1.012-.066 2.059-.1 3.114-.1a.616.616 0 0 1 0 1.231c-1.029 0-2.05.036-3.036.1h-.041"
                      fill="#f47e58"
                    />
                    <path
                      data-name="Path 100220"
                      d="M233.207 155.226a164.285 164.285 0 0 0-11.346 17.841 87.1 87.1 0 0 0-9.864 32.314 665.95 665.95 0 0 0-7.916-.322c-16.944-.6-41.405-.978-68.6-.978-30.922 0-58.3.487-75.126 1.237l-1.7.078c-21-26.03-63.291-71.38-24.373-90.036a72.966 72.966 0 0 0 7.126-2.734c13.529-5.9 41.329-21.793 38.237-51.751a79.809 79.809 0 0 1-1.054-13.369c0-18.188 5.758-48.337 44.2-46.961a73.09 73.09 0 0 1 57.68 31.642c12.714 18.6 33.042 41.479 49.6 28.416a15.312 15.312 0 0 1 13.592-2.808c11.916 3.347 25.453 20.674-10.449 97.431"
                      fill="#fbdacf"
                      stroke="rgba(0,0,0,0)"
                    />
                  </g>
                </g>
              </g>
              <g data-name="Group 112114" opacity={0.15}>
                <g data-name="Group 112113">
                  <g
                    data-name="Group 112112"
                    clipPath="url(#a)"
                    transform="translate(6.831 204.165)"
                  >
                    <path
                      data-name="Path 100221"
                      d="M257.289.437c0 .242-57.6.438-128.644.438-40.088 0-75.893-.062-99.487-.16C23.724.693 18.938.668 14.897.642c-2.662-.017-5-.035-6.988-.053C2.794.542 0 .489 0 .438S4.534.306 12.627.249C15.941.225 19.852.203 24.293.182 47.658.072 85.693 0 128.645 0c37.781 0 71.758.055 95.293.144 20.723.078 33.351.181 33.351.294"
                      fill="#040c2b"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
          <g data-name="Group 112175">
            <g data-name="Group 112315">
              <g data-name="Path 100222" fill="#fac8b7">
                <path d="m176.855 42.72-8.427 15.792a1.228 1.228 0 0 1-1.661.505l-13.965-7.452a1.228 1.228 0 0 1-.505-1.661l9.979-18.7a1.228 1.228 0 0 1 1.661-.505l10.985 5.862.035.11Z" />
                <path
                  d="M163.359 31.556a.228.228 0 0 0-.202.12l-9.979 18.7a.224.224 0 0 0-.017.173.224.224 0 0 0 .111.135l13.965 7.451c.033.018.07.028.106.028a.229.229 0 0 0 .202-.121l8.23-15.422-1.685-5.368-10.625-5.67a.223.223 0 0 0-.106-.026m0-1c.195 0 .393.046.577.144l10.985 5.863.035.11 1.899 6.047-8.428 15.793a1.228 1.228 0 0 1-1.661.505L152.8 51.566a1.228 1.228 0 0 1-.505-1.661l9.979-18.7c.22-.414.645-.65 1.084-.65Z"
                  fill="rgba(0,0,0,0)"
                />
              </g>
              <g data-name="Group 112119" opacity={0.1}>
                <g data-name="Group 112118">
                  <g
                    data-name="Group 112117"
                    clipPath="url(#b)"
                    transform="translate(173.218 36.673)"
                  >
                    <path
                      data-name="Path 100223"
                      d="M3.637 6.048.529 4.389a1 1 0 0 1-.411-1.352L1.739 0Z"
                    />
                  </g>
                </g>
              </g>
              <path
                data-name="Path 100224"
                d="m163.199 45.805.264-.5a2.493 2.493 0 0 1 .872-.973 4.085 4.085 0 0 1 1.545-.476 4.768 4.768 0 0 0 1.365-.322 1.342 1.342 0 0 0 .6-.584.864.864 0 0 0 .032-.835 1.741 1.741 0 0 0-.776-.707 5.846 5.846 0 0 0-2.643-.566l.053-1.857a7.237 7.237 0 0 1 3.617.854 3.822 3.822 0 0 1 1.841 1.835 2.456 2.456 0 0 1-.13 2.2 2.668 2.668 0 0 1-1.015 1.094 5.413 5.413 0 0 1-1.917.527 4.456 4.456 0 0 0-1.2.289 1.273 1.273 0 0 0-.518.559l-.215.4Zm-1.438 2.178a1.274 1.274 0 0 1 .756-.69 1.387 1.387 0 0 1 1.032.18 1.349 1.349 0 0 1 .7.755 1.476 1.476 0 0 1-.9 1.677 1.323 1.323 0 0 1-1.021-.153 1.362 1.362 0 0 1-.712-.763 1.264 1.264 0 0 1 .14-1.006"
                fill="#fdece7"
              />
              <path
                data-name="Path 100225"
                d="M62.062 126.591 52.1 141.877a1.252 1.252 0 0 1-1.732.365l-13.517-8.809a1.251 1.251 0 0 1-.365-1.732l11.8-18.1a1.251 1.251 0 0 1 1.732-.365l10.633 6.93.025.115Z"
                fill="#fac8b7"
                stroke="rgba(0,0,0,0)"
              />
              <g data-name="Group 112122" opacity={0.1}>
                <g data-name="Group 112121">
                  <g
                    data-name="Group 112120"
                    clipPath="url(#c)"
                    transform="translate(58.591 120.282)"
                  >
                    <path
                      data-name="Path 100226"
                      d="M3.471 6.31.463 4.349a1.019 1.019 0 0 1-.3-1.41L2.079 0Z"
                    />
                  </g>
                </g>
              </g>
              <g data-name="Path 100227" fill="#fdece7">
                <path d="m51.243 133.727-1.8-1.175.1-3.943-3.566 1.687-1.69-1.1 4.971-2.229.038-5.111 1.741 1.135-.142 3.723 3.318-1.653 1.7 1.108-4.742 2.168Z" />
                <path
                  d="m51.243 133.727-1.803-1.174.104-3.944-3.566 1.687-1.69-1.101 4.971-2.23.038-5.11 1.74 1.134-.14 3.723 3.318-1.652 1.7 1.108-4.742 2.168.07 5.391Z"
                  fill="rgba(0,0,0,0)"
                />
              </g>
              <g data-name="Path 100228" fill="#fac8b7">
                <path d="m235.226 78.184 6.535 17.035a1.252 1.252 0 0 1-.72 1.617l-15.063 5.779a1.251 1.251 0 0 1-1.617-.72l-7.738-20.17a1.251 1.251 0 0 1 .72-1.617l11.85-4.546.108.047Z" />
                <path
                  d="m229.169 76.641-11.468 4.4a.246.246 0 0 0-.14.132.247.247 0 0 0-.005.192l7.738 20.17a.254.254 0 0 0 .325.145l15.063-5.778c.08-.031.12-.09.14-.133a.247.247 0 0 0 .005-.192l-6.385-16.643-5.273-2.293m.024-1.08.107.047 5.926 2.576 6.535 17.035a1.252 1.252 0 0 1-.72 1.616l-15.064 5.78a1.252 1.252 0 0 1-1.617-.721l-7.737-20.17a1.251 1.251 0 0 1 .72-1.617l11.85-4.546Z"
                  fill="rgba(0,0,0,0)"
                />
              </g>
              <g data-name="Group 112125" opacity={0.1}>
                <g data-name="Group 112124">
                  <g
                    data-name="Group 112123"
                    clipPath="url(#d)"
                    transform="translate(229.3 75.607)"
                  >
                    <path
                      data-name="Path 100229"
                      d="M5.926 2.576 2.573 3.862a1.018 1.018 0 0 1-1.316-.586L0 0Z"
                    />
                  </g>
                </g>
              </g>
              <path
                data-name="Path 100230"
                d="m233.698 92.859-1.275.489-1.783-.984-.667 1.924-1.2.459.987-2.653-2.35-1.234 1.232-.473 1.666.948.583-1.811 1.2-.462-.922 2.541Z"
                fill="#fdece7"
              />
              <path
                data-name="Path 100231"
                d="m233.148 81.413-11.644 4.467a.27.27 0 1 1-.193-.5l11.644-4.467a.27.27 0 1 1 .193.5"
                fill="#fdece7"
              />
              <path
                data-name="Path 100232"
                d="m233.651 82.672-11.644 4.467a.27.27 0 0 1-.193-.5l11.644-4.467a.27.27 0 0 1 .193.5"
                fill="#fdece7"
              />
              <path
                data-name="Path 100233"
                d="m234.154 83.931-11.644 4.467a.27.27 0 0 1-.193-.5l11.644-4.467a.27.27 0 0 1 .193.5"
                fill="#fdece7"
              />
              <path
                data-name="Path 100234"
                d="m234.657 85.19-11.644 4.467a.27.27 0 1 1-.193-.5l11.644-4.467a.27.27 0 0 1 .193.5"
                fill="#fdece7"
              />
              <path
                data-name="Path 100235"
                d="m235.065 86.49-11.648 4.466a.27.27 0 1 1-.193-.5l11.644-4.467a.27.27 0 1 1 .193.5"
                fill="#fdece7"
              />
              <g data-name="Path 100236" fill="#fac8b7">
                <path d="m64.754 171.299 7.35 16.7a1.251 1.251 0 0 1-.641 1.649l-14.767 6.5a1.251 1.251 0 0 1-1.65-.641l-8.7-19.773a1.251 1.251 0 0 1 .641-1.65l11.617-5.113.11.042Z" />
                <path
                  d="M58.626 170.051 47.383 175a.247.247 0 0 0-.133.139.247.247 0 0 0 .005.192l8.702 19.774a.252.252 0 0 0 .331.128l14.768-6.499a.247.247 0 0 0 .133-.138.247.247 0 0 0-.005-.193l-7.18-16.316-5.378-2.035m-.029-1.08.11.042 6.043 2.286L72.1 188a1.251 1.251 0 0 1-.642 1.65l-14.767 6.499a1.251 1.251 0 0 1-1.65-.641l-8.702-19.774a1.251 1.251 0 0 1 .642-1.65l11.616-5.112Z"
                  fill="rgba(0,0,0,0)"
                />
              </g>
              <g data-name="Group 112128" opacity={0.1}>
                <g data-name="Group 112127">
                  <g
                    data-name="Group 112126"
                    clipPath="url(#e)"
                    transform="translate(58.707 169.013)"
                  >
                    <path
                      data-name="Path 100237"
                      d="M6.043 2.287 2.756 3.734a1.019 1.019 0 0 1-1.343-.522L0 .001Z"
                    />
                  </g>
                </g>
              </g>
              <g data-name="Path 100238" fill="#fdece7">
                <path d="m63.932 186.032-1.25.55-1.828-.9-.573 1.954-1.173.516.857-2.7-2.407-1.12 1.208-.531 1.709.866.495-1.836 1.18-.519-.8 2.583Z" />
                <path
                  d="m59.107 188.156.858-2.698-2.407-1.12 1.208-.532 1.71.867.494-1.837 1.18-.519-.8 2.583 2.582 1.132-1.25.55-1.829-.897-.573 1.954-1.173.517Z"
                  fill="rgba(0,0,0,0)"
                />
              </g>
              <path
                data-name="Path 100239"
                d="m62.83 174.626-11.415 5.024a.27.27 0 1 1-.217-.494l11.415-5.023a.27.27 0 1 1 .217.494"
                fill="#fdece7"
                stroke="rgba(0,0,0,0)"
              />
              <path
                data-name="Path 100240"
                d="m63.39 175.859-11.415 5.023a.27.27 0 1 1-.217-.494l11.415-5.024a.27.27 0 1 1 .217.494"
                fill="#fdece7"
                stroke="rgba(0,0,0,0)"
              />
              <path
                data-name="Path 100241"
                d="m63.956 177.092-11.415 5.024a.27.27 0 0 1-.217-.494l11.415-5.024a.27.27 0 0 1 .217.494"
                fill="#fdece7"
                stroke="rgba(0,0,0,0)"
              />
              <path
                data-name="Path 100242"
                d="m64.52 178.325-11.415 5.024a.27.27 0 0 1-.217-.494l11.414-5.024a.27.27 0 0 1 .218.494"
                fill="#fdece7"
                stroke="rgba(0,0,0,0)"
              />
              <path
                data-name="Path 100243"
                d="m64.989 179.604-11.415 5.024a.27.27 0 0 1-.217-.494l11.415-5.024a.27.27 0 0 1 .217.494"
                fill="#fdece7"
                stroke="rgba(0,0,0,0)"
              />
              <g data-name="Path 100244" fill="#fac8b7">
                <path d="m115.769 50.746 7.35 16.7a1.252 1.252 0 0 1-.641 1.65l-14.767 6.5a1.251 1.251 0 0 1-1.65-.641l-8.7-19.773a1.252 1.252 0 0 1 .641-1.65l11.617-5.113.11.042Z" />
                <path
                  d="m109.64 49.497-11.242 4.948a.252.252 0 0 0-.128.331l8.702 19.774a.253.253 0 0 0 .331.129l14.768-6.5a.252.252 0 0 0 .128-.33l-7.18-16.317-5.378-2.035m-.029-1.08 6.153 2.329 7.35 16.7a1.252 1.252 0 0 1-.642 1.649l-14.767 6.499a1.251 1.251 0 0 1-1.65-.641l-8.702-19.774a1.252 1.252 0 0 1 .642-1.65l11.616-5.112Z"
                  fill="rgba(0,0,0,0)"
                />
              </g>
              <g data-name="Group 112131" opacity={0.1}>
                <g data-name="Group 112130">
                  <g
                    data-name="Group 112129"
                    clipPath="url(#f)"
                    transform="translate(109.722 48.459)"
                  >
                    <path
                      data-name="Path 100245"
                      d="M6.043 2.287 2.756 3.733a1.019 1.019 0 0 1-1.343-.522L0 0Z"
                    />
                  </g>
                </g>
              </g>
              <path
                data-name="Path 100246"
                d="m114.947 65.479-1.25.55-1.828-.9-.573 1.954-1.173.516.857-2.7-2.407-1.12 1.208-.532 1.709.866.495-1.836 1.18-.519-.8 2.583Z"
                fill="#fdece7"
              />
              <path
                data-name="Path 100247"
                d="m113.846 54.072-11.415 5.024a.27.27 0 0 1-.356-.138.27.27 0 0 1 .138-.356l11.415-5.024a.27.27 0 0 1 .217.494"
                fill="#fdece7"
              />
              <path
                data-name="Path 100248"
                d="m114.406 55.305-11.415 5.024a.27.27 0 0 1-.218-.494l11.415-5.024a.27.27 0 1 1 .218.494"
                fill="#fdece7"
              />
              <path
                data-name="Path 100249"
                d="m114.973 56.538-11.415 5.024a.27.27 0 0 1-.217-.494l11.415-5.024a.27.27 0 1 1 .218.494"
                fill="#fdece7"
              />
              <path
                data-name="Path 100250"
                d="m115.536 57.771-11.415 5.024a.27.27 0 0 1-.217-.494l11.415-5.024a.27.27 0 0 1 .218.494"
                fill="#fdece7"
              />
              <path
                data-name="Path 100251"
                d="m116.005 59.05-11.415 5.024a.27.27 0 0 1-.217-.494l11.415-5.024a.27.27 0 1 1 .217.494"
                fill="#fdece7"
              />
              <g
                data-name="Rectangle 57201"
                fill="#fbdacf"
                stroke="rgba(0,0,0,0)"
              >
                <path stroke="none" d="M78.395 97.354h114.16v82.839H78.395z" />
                <path fill="none" d="M78.895 97.854h113.16v81.839H78.895z" />
              </g>
              <path
                data-name="Rectangle 57202"
                fill="#fac8b7"
                stroke="rgba(0,0,0,0)"
                d="M78.437 86.955h114.116v10.422H78.437z"
              />
              <path
                data-name="Path 100252"
                d="M85.468 91.679a1.756 1.756 0 1 1-1.754-1.667 1.712 1.712 0 0 1 1.754 1.667"
                fill="#e3e9f7"
              />
              <path
                data-name="Path 100253"
                d="M90.58 91.679a1.756 1.756 0 1 1-1.754-1.667 1.712 1.712 0 0 1 1.754 1.667"
                fill="#e3e9f7"
              />
              <path
                data-name="Path 100254"
                d="M95.699 91.679a1.756 1.756 0 1 1-1.754-1.667 1.712 1.712 0 0 1 1.754 1.667"
                fill="#e3e9f7"
              />
              <g
                data-name="Rectangle 57203"
                fill="#fdece7"
                stroke="rgba(0,0,0,0)"
              >
                <path stroke="none" d="M81.83 101.715h107.29v74.117H81.83z" />
                <path fill="none" d="M82.33 102.215h106.29v73.117H82.33z" />
              </g>
              <path
                data-name="Path 100255"
                d="M152.118 119.939v32.586a2.235 2.235 0 0 1-2.235 2.235h-28.816a2.235 2.235 0 0 1-2.235-2.235V113.94a2.235 2.235 0 0 1 2.235-2.235h22.669l.15.147Z"
                fill="#fac8b7"
                stroke="rgba(0,0,0,0)"
              />
              <g data-name="Group 112134" opacity={0.15}>
                <g data-name="Group 112133">
                  <g
                    data-name="Group 112132"
                    clipPath="url(#g)"
                    transform="translate(143.885 111.853)"
                  >
                    <path
                      data-name="Path 100256"
                      d="M8.233 8.086H1.82A1.82 1.82 0 0 1 0 6.266V0Z"
                    />
                  </g>
                </g>
              </g>
              <path
                data-name="Path 100257"
                d="M143.468 138.739a.587.587 0 0 1-.555-.4 3.508 3.508 0 0 0-1.964-1.732 14.808 14.808 0 0 0-10.949 0 3.508 3.508 0 0 0-1.964 1.732.585.585 0 1 1-1.111-.366 4.532 4.532 0 0 1 2.582-2.425 15.953 15.953 0 0 1 11.935 0 4.532 4.532 0 0 1 2.582 2.425.585.585 0 0 1-.556.769"
                fill="#fff"
              />
              <path
                data-name="Path 100258"
                d="M133.606 130.152a2.424 2.424 0 1 1-2.424-2.424 2.424 2.424 0 0 1 2.424 2.424"
                fill="#fff"
              />
              <path
                data-name="Path 100259"
                d="M142.193 130.152a2.424 2.424 0 1 1-2.424-2.424 2.424 2.424 0 0 1 2.424 2.424"
                fill="#fff"
              />
              <path
                data-name="Path 100260"
                d="M126.146 165.784h-1.118l-1.8-3.138h-.026q.054.831.054 1.186v1.952h-.786v-4.148h1.109l1.8 3.107h.02q-.042-.809-.042-1.143v-1.963h.792Z"
                fill="#fac8b7"
              />
              <path
                data-name="Path 100261"
                d="M130.954 163.704a2.25 2.25 0 0 1-.511 1.583 2.213 2.213 0 0 1-2.928 0 2.259 2.259 0 0 1-.511-1.589 2.229 2.229 0 0 1 .512-1.582 1.916 1.916 0 0 1 1.468-.546 1.888 1.888 0 0 1 1.463.55 2.258 2.258 0 0 1 .506 1.583m-3.027 0a1.732 1.732 0 0 0 .264 1.047.923.923 0 0 0 .789.352q1.052 0 1.052-1.4t-1.047-1.4a.929.929 0 0 0-.792.353 1.726 1.726 0 0 0-.267 1.048"
                fill="#fac8b7"
              />
              <path
                data-name="Path 100262"
                d="M136.765 163.671a2.043 2.043 0 0 1-.583 1.569 2.378 2.378 0 0 1-1.684.545h-1.175v-4.148h1.3a2.192 2.192 0 0 1 1.577.536 1.972 1.972 0 0 1 .562 1.5m-.914.023q0-1.336-1.18-1.336h-.468v2.7h.377q1.271 0 1.271-1.365"
                fill="#fac8b7"
              />
              <path
                data-name="Path 100263"
                d="m140.163 165.785-.3-.987h-1.512l-.3.987h-.948l1.464-4.165h1.075l1.469 4.165Zm-.511-1.725q-.417-1.342-.469-1.518t-.075-.278q-.094.363-.536 1.8Z"
                fill="#fac8b7"
              />
              <path
                data-name="Path 100264"
                d="M143.233 165.784h-.879v-3.416h-1.126v-.732h3.132v.732h-1.126Z"
                fill="#fac8b7"
              />
              <path
                data-name="Path 100265"
                d="m147.542 165.785-.3-.987h-1.512l-.3.987h-.948l1.464-4.165h1.075l1.469 4.165Zm-.511-1.725q-.417-1.342-.469-1.518t-.075-.278q-.094.363-.536 1.8Z"
                fill="#fac8b7"
              />
              <path
                data-name="Path 100266"
                d="M208.205 143.563h3.467a4.727 4.727 0 0 0 0-9.453h-3.467a4.727 4.727 0 0 0 0 9.453"
                fill="#fac8b7"
                stroke="rgba(0,0,0,0)"
              />
              <path
                data-name="Path 100267"
                d="M208.439 142.801h3a4.86 4.86 0 0 1-3 3.614s1.436-2.115 0-3.614"
                fill="#fac8b7"
                stroke="rgba(0,0,0,0)"
              />
              <path
                data-name="Path 100268"
                d="M209.199 139.776v-.286a1.269 1.269 0 0 1 .158-.646 2.076 2.076 0 0 1 .58-.584 2.423 2.423 0 0 0 .536-.472.682.682 0 0 0 .13-.406.44.44 0 0 0-.186-.383.888.888 0 0 0-.518-.131 2.976 2.976 0 0 0-1.323.379l-.422-.847a3.686 3.686 0 0 1 1.83-.484 1.945 1.945 0 0 1 1.267.383 1.25 1.25 0 0 1 .47 1.021 1.358 1.358 0 0 1-.194.735 2.753 2.753 0 0 1-.735.7 2.28 2.28 0 0 0-.47.418.65.65 0 0 0-.1.375v.232Zm-.124 1.323a.648.648 0 0 1 .174-.491.705.705 0 0 1 .507-.166.686.686 0 0 1 .5.17.752.752 0 0 1 0 .969.674.674 0 0 1-.5.176.7.7 0 0 1-.5-.172.644.644 0 0 1-.178-.486"
                fill="#fdece7"
              />
              <g data-name="Group 112137" opacity={0.67}>
                <g data-name="Group 112136">
                  <g
                    data-name="Group 112135"
                    clipPath="url(#h)"
                    transform="translate(197.201 202.868)"
                  >
                    <path
                      data-name="Path 100269"
                      d="m1.621 0 1.621.631-.473 2.287-2.77-.868Z"
                      fill="#050505"
                    />
                  </g>
                </g>
              </g>
              <path
                data-name="Path 100270"
                d="M176.226 197.801s-4.323-.513-5.269 1.814c0 0-.068 5.8 2.635 6.191a6.525 6.525 0 0 0 3.783-.789l8.647-.986 5.877-.394Z"
                fill="#fbdacf"
              />
              <path
                data-name="Path 100271"
                d="M202.2 200.58s2.269 3.65.926 5.1c-.208.225.082.5.52.5l9.127-.017s5.2.946 6.215-3.036c0 0 .608-4.219-6.012-4.929s-.068-.237-.068-.237-7.7.552-10.708 2.622"
                fill="#fbdacf"
              />
              <path
                data-name="Path 100272"
                d="m205.815 200.758-.025.233-.515 4.814-9.627-.848 3.168-4.146.04-.053c6.958.158 6.958 0 6.958 0"
                fill="#de995f"
              />
              <g data-name="Group 112140" opacity={0.38}>
                <g data-name="Group 112139">
                  <g
                    data-name="Group 112138"
                    clipPath="url(#i)"
                    transform="translate(198.816 200.758)"
                  >
                    <path
                      data-name="Path 100273"
                      d="m6.999 0-.025.233-5.075.141-1.9-.321L.039 0c6.958.158 6.958 0 6.958 0"
                      fill="#050505"
                    />
                  </g>
                </g>
              </g>
              <path
                data-name="Path 100274"
                d="m220.589 192.45-11.21 2.178-14.708 2.857-11.683-2.719-18.448-4.294c-.843-6.335 12.431-2.687 12.431-2.687l8.642.969 5.07.569 11.484 1.577 3.648-1.444 4.323-1.711c11.653-1.006 10.448 4.7 10.448 4.7"
                fill="#f26c40"
              />
              <g data-name="Group 112143" opacity={0.3}>
                <g data-name="Group 112142">
                  <g
                    data-name="Group 112141"
                    clipPath="url(#j)"
                    transform="translate(179.806 188.754)"
                  >
                    <path
                      data-name="Path 100275"
                      d="M29.57 5.874 14.862 8.731 3.179 6.012 0 4.118 5.8 0l5.07.569 11.484 1.577L26.002.702Z"
                      fill="#f26c40"
                    />
                  </g>
                </g>
              </g>
              <path
                data-name="Path 100276"
                d="m178.252 199.654 15.875-4.14s11.349-4.219 13.308-3.983c0 0 14.052-7.216 13.106 1.617 0 0 1.621 6.94-23.442 8.005Z"
                fill="#f47e58"
              />
              <g data-name="Group 112146" opacity={0.13}>
                <g data-name="Group 112145">
                  <g
                    data-name="Group 112144"
                    clipPath="url(#k)"
                    transform="translate(189.163 196.282)"
                  >
                    <path
                      data-name="Path 100277"
                      d="M.004.513 1.761 0C3.09.886 5.588 1.623 7.233 2.366a36.094 36.094 0 0 0 6.282 2.13l-4.256.512Z"
                    />
                  </g>
                </g>
              </g>
              <path
                data-name="Path 100278"
                d="M201.457 200.896s-4.627 3.687-1.52 4.909c0 0-17.958-2.016-32.324-10.041a4.923 4.923 0 0 1-2.224-2.238c-1.316-3.094-3.134-10.134 11.039-4.126 0 0 11.009 3.74 14.637 6.958a11.542 11.542 0 0 0 2.476 1.66c2.271 1.144 6.121 2.93 7.916 2.876"
                fill="#f47e58"
              />
              <path
                data-name="Path 100279"
                d="m190.479 159.969 8.377.015 2.7 5.087s-5.269 7.966-12.835.868c.336-1.143 1.454-2.82 1.79-3.963.54-1.183.473-1.1-.034-2.006"
                fill="#fbdacf"
                stroke="rgba(0,0,0,0)"
              />
              <path
                data-name="Path 100280"
                d="m212.214 168.29-1.873 15-28.846-.276s1.98-7.638 1.585-8.878a.261.261 0 0 0-.1-.153l-7.972-.276a23.087 23.087 0 0 1 .321-2.538c.441-2.437 1.45-5.868 3.7-6.71.37-.138 1.452-.572 1.452-.572s9.83-2.583 10.032-1.913c0 0-.54 7.847 10.134 1.341 0 0 12.359 3.067 11.567 4.974"
                fill="#fff"
              />
              <path
                data-name="Path 100281"
                d="m206.355 184.038.591 4.97 6.659-2.021c1.51-.458 2.544-1.323 2.73-2.31a6.57 6.57 0 0 0-.725-3.873l-1.486-6.585s.709-4.554-2.736-7.118c0 0-1.25 7.552-3.479 8.813l-.473 6.309Z"
                fill="#fff"
              />
              <g data-name="Group 112149" opacity={0.1}>
                <g data-name="Group 112148">
                  <g
                    data-name="Group 112147"
                    clipPath="url(#l)"
                    transform="translate(175.009 163.611)"
                  >
                    <path
                      data-name="Path 100282"
                      d="m12.669 2.051-4.6 8.473a.261.261 0 0 0-.1-.153l-7.972-.276a23.087 23.087 0 0 1 .321-2.538L8.41-.001s3.446 2.011 4.256 2.051"
                    />
                  </g>
                </g>
              </g>
              <path
                data-name="Path 100283"
                d="M189.176 160.623a19.808 19.808 0 0 1-1.128 3.816l-1.081 2.051-3.04-2.051.811-.828-.405-3.746 1.026-2.51a2.176 2.176 0 0 1 2.228-1.358c1.074.115 2.123 1.059 1.59 4.625"
                fill="#fbdacf"
                stroke="rgba(0,0,0,0)"
              />
              <g data-name="Group 112152" opacity={0.13}>
                <g data-name="Group 112151">
                  <g
                    data-name="Group 112150"
                    clipPath="url(#m)"
                    transform="translate(181.022 165.875)"
                  >
                    <path
                      data-name="Path 100284"
                      d="m0 7.477 2.11 1.368-.657 4.212L7.026.537 5.033.001Z"
                    />
                  </g>
                </g>
              </g>
              <path
                data-name="Path 100285"
                d="M183.792 163.612s3.445 2.011 4.256 2.051l-6.485 11.948s-4.169 5.164-8.449 1.28c-2.637-2.392-1.787-5.58 2.069-7.319l.165-.073Z"
                fill="#fff"
              />
              <g data-name="Group 112155" opacity={0.13}>
                <g data-name="Group 112154">
                  <g
                    data-name="Group 112153"
                    clipPath="url(#n)"
                    transform="translate(190.446 159.215)"
                  >
                    <path
                      data-name="Path 100286"
                      d="M0 2.642s4.009 5.787 9.267-.261L7.634 0 .98.756Z"
                    />
                  </g>
                </g>
              </g>
              <path
                data-name="Path 100287"
                d="M188.723 151.782s7.7-4.219 10.809-.513c0 0 6.418 6.507-3.581 12.343 0 0-6.485 2.879-7.228-11.83"
                fill="#fbdacf"
                stroke="rgba(0,0,0,0)"
              />
              <path
                data-name="Path 100288"
                d="m189.559 157.931-2.008-3.358a4.062 4.062 0 0 1-.61-2.4c.187-2.554 1.745-7.458 11.307-5.32 0 0 8.377 3.667 3.716 8.36l-1.554 3.391s.2-6.112-2.162-6.428a48.44 48.44 0 0 1-8.917 1.1s-.1 4.2.227 4.651"
              />
              <path
                data-name="Path 100289"
                d="M191.425 157.287c-1.041 0-1.887-.506-1.887-1.128s.847-1.128 1.887-1.128 1.887.506 1.887 1.128-.847 1.128-1.887 1.128m0-2.129c-.971 0-1.76.449-1.76 1s.79 1 1.76 1 1.76-.449 1.76-1-.79-1-1.76-1"
              />
              <path
                data-name="Path 100290"
                d="M196.961 157.126c-1.041 0-1.887-.506-1.887-1.128s.847-1.128 1.887-1.128 1.887.506 1.887 1.128-.847 1.128-1.887 1.128m0-2.129c-.971 0-1.76.449-1.76 1s.79 1 1.76 1 1.76-.449 1.76-1-.79-1-1.76-1"
              />
              <path
                data-name="Path 100291"
                d="M194.162 156.311a1.853 1.853 0 0 1-.968-.258l.07-.106a1.911 1.911 0 0 0 1.848 0l.058.113a2.2 2.2 0 0 1-1.008.254"
              />
              <path
                data-name="Rectangle 57212"
                d="m188.654 155.6.07-.105.913.61-.07.106z"
              />
              <path
                data-name="Rectangle 57213"
                d="m198.781 155.938 2.296-.276.016.126-2.297.276z"
              />
              <g data-name="Group 112158" opacity={0.13}>
                <g data-name="Group 112157">
                  <g
                    data-name="Group 112156"
                    clipPath="url(#o)"
                    transform="translate(206.929 181.404)"
                  >
                    <path
                      data-name="Path 100292"
                      d="M0 2.457A9.182 9.182 0 0 1 4.458.722s-.54-.355-2.027 0A4.436 4.436 0 0 1 5.336.209 4.462 4.462 0 0 0-.001 2.457"
                    />
                  </g>
                </g>
              </g>
              <path
                data-name="Path 100293"
                d="m180.127 178.981 27.071-.337a.7.7 0 0 1 .71.7v11.26a.7.7 0 0 1-.694.7l-26.531.3a.7.7 0 0 1-.708-.667l-.541-11.218a.7.7 0 0 1 .692-.735"
                fill="#fbdacf"
                stroke="rgba(0,0,0,0)"
              />
              <g data-name="Group 112164" opacity={0.13}>
                <g data-name="Group 112163">
                  <g
                    data-name="Group 112162"
                    clipPath="url(#p)"
                    transform="translate(167.883 187.285)"
                  >
                    <path
                      data-name="Path 100294"
                      d="M12.768 3.674S8.243.851 0 .007c0 0 4.121-.276 13.173 2.839Z"
                      fill="#f47e58"
                    />
                  </g>
                </g>
              </g>
              <g data-name="Group 112167" opacity={0.13}>
                <g data-name="Group 112166">
                  <g
                    data-name="Group 112165"
                    clipPath="url(#q)"
                    transform="translate(206.929 188.643)"
                  >
                    <path
                      data-name="Path 100295"
                      d="M1.013 2.67S9.191-1.516 12.449.725c0 0-1.708-2.471-12.449 1.709Z"
                    />
                  </g>
                </g>
              </g>
              <g data-name="Group 112170" opacity={0.13}>
                <g data-name="Group 112169">
                  <g
                    data-name="Group 112168"
                    clipPath="url(#r)"
                    transform="translate(207.875 169.665)"
                  >
                    <path
                      data-name="Path 100296"
                      d="M0 6.23s4.526-3.391 4.391-5.126c0 0-1.216 1.538-1.554 1.814 0 0 1.689-2.09 1.013-2.918 0 0-.943 2.625-1.654 2.673Z"
                    />
                  </g>
                </g>
              </g>
              <g data-name="Group 112173" opacity={0.13}>
                <g data-name="Group 112172">
                  <g
                    data-name="Group 112171"
                    clipPath="url(#s)"
                    transform="translate(207.841 168.896)"
                  >
                    <path
                      data-name="Path 100297"
                      d="M0 6.98S3.378.355 2.7 0c0 0-.135 1.3-2.7 6.98"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </g>
      </g>
      {/* <text
        data-name="No Data Found"
        transform="translate(136 243.502)"
        fill="#98a0ac"
        fontSize={20}
        fontFamily="NunitoSans-SemiBold, Nunito Sans"
        fontWeight={600}
      >
        <tspan x={-68.55} y={0}>
          {"No Data Found"}
        </tspan>
      </text> */}
    </g>
  </svg>
)
export default NoDataShow



